import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ObjectifModel, UserModel, BuildingModel, Colors } from '../../main/Models/';


@Component({
  selector: 'rm-objectif-resume',
  templateUrl: './t_objectif-resume.component.html',
  styleUrls: ['./objectif-resume.component.less']
})
export class ObjectifResumeComponent implements OnInit {

  @Input() objectif: ObjectifModel;

  @Output() onOpen:EventEmitter<null> = new EventEmitter();

  showDougnut:boolean = true;

  constructor() { }

  ngOnInit() {
  }

  get answerColor()
  {
    if(this.objectif.answer)
    	return this.objectif.answer.slice.color;
    else
      return '#1b6ba8';
  }

  get answerName()
  {
    if(this.objectif.answer)
      return this.objectif.answer.slice.name;
    else
      return 'Hors audit';
  }

  open(showIndicator:boolean = false)
  {
    this.objectif.showIndicator = showIndicator;
    this.onOpen.emit();
  }
}